import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FiTrash2 } from "react-icons/fi";
import {
  AddIcon,
  Card,
  Discount,
  ProductActions,
  ProductAvailabilityInfo,
  ProductDetails,
  ProductInfo,
  ProductTitle,
  ProductValue,
  QuantityWrap,
  RemoveButton,
  RemoveIcon,
  SpecialPrice,
  SpecialPriceContainer,
  ThumbnailWrap,
} from "./styles";
import { useDispatch } from "react-redux";
import { Creators as CartActions } from "../../store/ducks/cart";
import { formatPrice } from "../../util/format";
import { ThemeContext } from "styled-components";
import Loader from "react-loader-spinner";
import { PriceType } from "../../util/priceType";
import { isAlternativePriceType } from "../../util/price";
import { productImageSrc, handleProductImageError } from "../../util/imageFallback";

const ProductCard = ({ index, promotion, allowHandleQuantity, loadingItemInCart, productIdInChanging, pickupOnly = false }) => {
  const showDiscount = false;
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(promotion.promotionQuantity);
  const theme = useContext(ThemeContext);
  const [isChanging, setIsChanging] = useState(false);

  useEffect(() => {
    setQuantity(promotion.promotionQuantity);
  }, [promotion.promotionQuantity]);

  useEffect(() => {
    if (productIdInChanging === promotion.product.id) {
      setIsChanging(true);
    } else if (!productIdInChanging && isChanging) {
      setQuantity(promotion.promotionQuantity);
      setIsChanging(false);
    }
  }, [productIdInChanging]);

  const showDiscountTemplate = (promotion, isMobile) => {
    const isTakeMorePayLess = promotion.type === PriceType.TAKEMOREPAYLESS;
    const isAlternativePromotion = isAlternativePriceType(promotion.type);
    // Mesmos termos do quadro de preço especial da página do produto (CardSpecialPriceProduct)
    const specialPriceLabel = isTakeMorePayLess && promotion.takeQuantity && promotion.payQuantity
      ? `Leve ${promotion.takeQuantity} Pague ${promotion.payQuantity}`
      : promotion.type === PriceType.MINIMUN && promotion.minimunQuantity
        ? `A partir de ${promotion.minimunQuantity} un.`
        : promotion.type === PriceType.MULTIPLE && promotion.multipleQuantity
          ? `A cada ${promotion.multipleQuantity} un.`
          : "Preço especial";

    return isAlternativePromotion ||
      promotion.hasFacilityProgramInPriceBy ? (
      <SpecialPriceContainer className={isMobile ? "isMobile" : "isDesktop"}>
        {promotion.discount && promotion.discount > 0 && (
          <div className="biggest-discount">
            <span>{parseFloat(promotion.discount)}% OFF</span>
          </div>
        )}
        {isAlternativePromotion && (
          <>
            <SpecialPrice>
              <span>{specialPriceLabel}</span>
            </SpecialPrice>
          </>
        )}
      </SpecialPriceContainer>
    ) : null;
  };

  const showPricePromotion = (promotion) => {
    return (
      <div className="fidelity-price-container">
        {
          promotion.priceOf !== promotion.priceBy ? (
            <p className="old-price-text">
              De{" "}
              <span className="old-price">
                {formatPrice(
                  parseFloat(
                    promotion.priceOf
                  )
                )}
              </span>
            </p>
          ) : null}
        <div className="fidelity-price">
          <span className="new-price">
            {formatPrice(
              parseFloat(
                promotion.priceBy
              )
            )}
          </span>
        </div>
      </div>
    );
  };

  const handleChange = (value, promotion, key) => {
    let newValue = value !== "" ? parseInt(value) : 1;
    const currentQuantityPromotion = promotion.promotionQuantity;
    const totalQuantity = promotion.totalQuantity;

    let newTotalQuantity = totalQuantity - currentQuantityPromotion + newValue;
    if (newTotalQuantity > 50)
      newTotalQuantity = 50
    else if (value < 0)
      newTotalQuantity = value * -1

    setQuantity(newTotalQuantity.toString());

    if (promotion.promotionQuantity === newTotalQuantity)
      return

    dispatch(CartActions.addProduct(promotion.product, newTotalQuantity, false, true, false, true));

  };

  const handleDelete = (e) => {
    var evt = e || window.event;
    if (evt) {
      var keyCode = evt.charCode || evt.keyCode;
      if (keyCode === 8 || keyCode === 46 || keyCode === 17) {
        if (evt.preventDefault) {
          evt.preventDefault();
        } else {
          evt.returnValue = false;
        }
      }
    }
  };

  const handleFocus = (e, promotion, key) => {
    const input = document.getElementById(`qtyInput${key}`);
    input.focus();
    input.select();
  };

  return (
    <Card>
      <ThumbnailWrap>
        <img
          src={productImageSrc(promotion.product)}
          onError={handleProductImageError(promotion.product)}
          alt={promotion.product.nome}
          title={promotion.product.nome}
        />
      </ThumbnailWrap>

      <ProductDetails>
        <ProductInfo>
          <ProductTitle to={`/produtos/visualizar/${promotion.product.url}`} lines={1}>
            {promotion.product.nome && promotion.product.nome.toLowerCase()}
          </ProductTitle>
          {pickupOnly && (
            <ProductAvailabilityInfo>Disponível apenas para retirada</ProductAvailabilityInfo>
          )}

          {showDiscountTemplate(promotion, true)}
          {showDiscountTemplate(promotion, false)}
        </ProductInfo>

        {showDiscount && promotion.discount > 0 && (
          <Discount>
            <span>
              {parseFloat(promotion.discount * -1).toLocaleString("pt-BR")}%
            </span>
          </Discount>
        )}

        <ProductValue>{showPricePromotion(promotion)}</ProductValue>
      </ProductDetails>

      <ProductActions style={{ opacity: loadingItemInCart && productIdInChanging !== promotion.product.id ? 0.5 : 1 }}>
        {loadingItemInCart && productIdInChanging === promotion.product.id ? (
          <Loader type="ThreeDots" color={theme.colors.primary} height={40} width={40} />
        ) : (
          <QuantityWrap>
            {allowHandleQuantity && (
              <button
                className="decrement-item"
                onClick={() =>
                  handleChange(promotion.promotionQuantity - 1, promotion, index)
                }
                disabled={loadingItemInCart}
              >
                <RemoveIcon size={22} />
              </button>
            )}
            <input
              className="qtyInput"
              onKeyDown={handleDelete()}
              onFocus={(e) => handleFocus(e, promotion, index)}
              type="number"
              id={`qtyInput${index}`}
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              onBlur={(e) => handleChange(e.target.value, promotion, index)}
              name={`qtyInput${promotion.key}`}
              disabled={loadingItemInCart}
            />
            {allowHandleQuantity && (
              <button
                className="increment-item"
                onClick={() =>
                  handleChange(promotion.promotionQuantity + 1, promotion, index)
                }
                disabled={loadingItemInCart}
              >
                <AddIcon size={22} />
              </button>
            )}
          </QuantityWrap>
        )}

        {allowHandleQuantity && productIdInChanging !== promotion.product.id && (
          <RemoveButton
            type="button"
            onClick={!loadingItemInCart ? () => handleChange(0, promotion, index) : null}
            disabled={loadingItemInCart}
          >
            <FiTrash2 />
            Remover
          </RemoveButton>
        )}
      </ProductActions>
    </Card>
  );
};

export default ProductCard;
